import { render, staticRenderFns } from "./LandingCardCta.vue?vue&type=template&id=6beeb729&scoped=true&"
import script from "./LandingCardCta.vue?vue&type=script&lang=js&"
export * from "./LandingCardCta.vue?vue&type=script&lang=js&"
import style0 from "./LandingCardCta.vue?vue&type=style&index=0&id=6beeb729&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6beeb729",
  null
  
)

export default component.exports